module.exports = __webpack_public_path__ + "img/keys_open.ae2683e1.svg";